/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import './index.css';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import Rating from '@mui/material/Rating';
import WriteReview from './WriteReviews';
import Loader from '../Loader';
import Header from '../Header';
import ReviewComponent from './ReviewComponent';

function MainContainer({ baseURL }) {
  const [page, setPage] = useState(1);
  const [getData, setGetData] = useState(null);
  const [loading, setLoading] = useState(false);
  const {
    linkid, templateid, contactid, type, 
  } = useParams();

  useEffect(() => {
    GetDataApi();
  }, []);

  const GetDataApi = async () => {
    setLoading(true);
    const response = await axios.get(`${baseURL}/testing/review-us/${linkid}/${templateid}/${contactid}`,{
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',         
      },
    });
    if (response.data.status === 'success') {
      setGetData(response?.data?.data);
      setLoading(false);
    }
  };

  const handleReviewActivity = async (value) => {
    // console.log('value',value);
    const formData = {
      contact_id: contactid,
      activity_action_name: 'clicked',
      performed_on: value,
      sent_via: type,
      template_type: getData.template.template_type_,
      company_id: getData?.template?.company_id,
      account_id: null,
    };
    const res = await axios.post(`${baseURL}/activity/add-activity`, formData);
    console.log('handleReviewActivity res', res);
    // if (value === 'Google' && getData?.template?.review_site_1_platform === 'Google') {
    //   // window.open(getData?.template?.review_site_1_url, '_self');
    // }
    // if (value === 'Facebook' && getData?.template?.review_site_2_platform === 'Facebook') {
    //   // window.open(getData?.template?.review_site_2_url, '_self');
    // }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="qs-page">
      <div className="qs-card min-h-[500px]">
        <Header 
          logo={getData?.display?.email_logo}
          headerColor={getData?.display?.email_header_color}
          headerTextColor={getData?.display?.email_header_text_color}
          companyName={getData?.name}
          ratingValue={(getData?.rating_average === null ? null : Number(Math.round((getData?.rating_average) * 10) / 10))}
          reviewCount={getData?.review_count}
        />

        <div className="qs-card-body flex-1">
          {page === 1 && (
          <ReviewComponent 
            getData={getData} 
            handleReviewActivity={handleReviewActivity} 
            setPage={setPage}
            page={page}
          />
          )}
          {page === 2 && (
          <WriteReview
            getData={getData} 
            baseURL={baseURL}
            templateid={templateid}
            contactid={contactid}
          />
          )}
        </div>
        <div className="qs-footer-note flex-wrap text-center">
          To unsubscribe click this 
          {'  '}
          <Link 
            className="qs-link pl-1"
            to={`/unsubscribe/${getData?.company_id}/${contactid}/${type}`}
          >
            link
          </Link> 
        </div>
      </div>
    </div>
  );
}

export default MainContainer;
